import React, { createContext, useState, useContext, useEffect } from 'react';
import { darkTheme, lightTheme } from '../themes/themes';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [isDarkMode, setIsDarkMode] = useState(() => {
        const savedTheme = localStorage.getItem('isDarkMode');
        return savedTheme ? JSON.parse(savedTheme) : false;
    });

    const toggleTheme = () => {
        setIsDarkMode((prev) => {
            const newTheme = !prev;
            localStorage.setItem('isDarkMode', JSON.stringify(newTheme));
            return newTheme;
        });
    };

    useEffect(() => {
        const theme = isDarkMode ? darkTheme : lightTheme;
        
        // Loop and update all other layout tokens seamlessly
        Object.keys(theme).forEach((key) => {
            document.documentElement.style.setProperty(`--${key}`, theme[key]);
        });

        // Keep the helper utility class in sync
        if (isDarkMode) {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
    }, [isDarkMode]);

    return (
        <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);